module.exports = __webpack_public_path__ + "static/media/p5_2.9d473e80.jpeg";